<div class="d-flex flex-column">
  <app-modal-header-common
    [dialogRef]="dialogRef"
    title="Tech Map"
  ></app-modal-header-common>

  <div class="d-flex flex-column flex-1">
    <!-- Breadcrumb -->
    <div class="breadcrumb-outer-container" *ngIf="data?.isBreadcrumb">
      <div class="breadcrumb">
        <ng-container
          *ngFor="let breadcrumb of breadCrumbData; let isLast = last"
        >
          <span
            [class.color-active]="isLast"
            [class.color-history-inactive]="!isLast"
          >
            {{ breadcrumb }}
          </span>
          <mat-icon *ngIf="!isLast" class="separator">chevron_right</mat-icon>
        </ng-container>
      </div>
    </div>

    <!-- Search -->
    <div class="search-container">
      <mat-form-field appearance="outline" class="search-field">
        <input
          matInput
          [(ngModel)]="applicationSearchTerm"
          (ngModelChange)="onApplicationSearch()"
          placeholder="Search application name..."
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <div class="tab-content">
      <div *ngIf="loading" class="loading-container">
        <app-loading></app-loading>
      </div>

      <!-- Tree Table -->
      <div *ngIf="!loading" class="tree-table-container">
        <table class="tree-table">
          <tbody>
            <ng-container
              *ngFor="let node of dataSource.data"
              [ngTemplateOutlet]="recursiveNode"
              [ngTemplateOutletContext]="{ $implicit: node, level: 0 }"
            >
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="dataSource.data.length === 0" class="empty-state">
          <p>{{ commonText?.no_data_found }}</p>
        </div>
      </div>

      <!-- Empty state -->
    </div>
  </div>

  <!-- Footer + Legend -->
  <div class="modal-footer">
    <div class="legend-container">
      <div class="legend-item" style="color: #1976d2">
        <mat-icon class="legend-icon">apps</mat-icon>
        <span class="legend-label">Application</span>
      </div>
      <div class="legend-item" style="color: #f57c00">
        <mat-icon class="legend-icon">dns</mat-icon>
        <span class="legend-label">Infrastructure</span>
      </div>
      <div class="legend-item" style="color: #424242">
        <mat-icon class="legend-icon">build</mat-icon>
        <span class="legend-label">Service</span>
      </div>
    </div>

    <button mat-button color="primary" (click)="onClose()">Close</button>
  </div>
</div>

<!-- Recursive Node Template -->
<ng-template #recursiveNode let-node let-level="level">
  <tr class="tree-row">
    <td class="col-name">
      <div class="name-cell" [style.padding-left.px]="level * 20">
        <button
          *ngIf="node.children?.length"
          mat-icon-button
          (click)="treeControl.toggle(node)"
        >
          <mat-icon>{{
            treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
          }}</mat-icon>
        </button>
        <button
          *ngIf="!node.children?.length"
          mat-icon-button
          disabled
        ></button>
        <mat-icon [ngClass]="getNodeClass(node)" class="node-icon">{{
          getNodeIcon(node)
        }}</mat-icon>
        <span
          class="node-label"
          [ngClass]="getNodeClass(node)"
          [matTooltip]="node.name"
          matTooltipPosition="above"
          >{{ node.name }}</span
        >
      </div>
    </td>

    <td class="col-1">
      <span
        [ngClass]="getColumnClass(node, 1)"
        [matTooltip]="getColumnTooltip(node, 1)"
        matTooltipPosition="above"
      >
        {{
          node.type === "application"
            ? node.data.sys_code
            : node.type === "infrastructure"
            ? node.data.usage_type?.name
            : node.data.service_type?.display_name
        }}
      </span>
    </td>

    <td class="col-2">
      <span
        [ngClass]="getColumnClass(node, 2)"
        [matTooltip]="getColumnTooltip(node, 2)"
        matTooltipPosition="above"
        class="wrap-two-lines"
      >
        {{
          node.type === "application"
            ? node.data.provider
            : node.type === "infrastructure"
            ? node.data.category
            : node.data.category
        }}
      </span>
    </td>

    <td class="col-3">
      <span
        [ngClass]="getColumnClass(node, 3)"
        [matTooltip]="getColumnTooltip(node, 3)"
        matTooltipPosition="above"
        class="wrap-two-lines"
      >
        {{
          node.type === "application"
            ? node.data.version
            : node.type === "infrastructure"
            ? node.data.subcategory
            : node.data.subcategory
        }}
      </span>
    </td>

    <td class="col-4">
      <span
        [ngClass]="getColumnClass(node, 4)"
        [matTooltip]="getColumnTooltip(node, 4)"
        matTooltipPosition="above"
        class="wrap-two-lines"
      >
        <!-- Show icon only for application or service AND only if value exists -->
        <mat-icon
          *ngIf="
            node.type !== 'infrastructure' &&
            (node.type === 'application'
              ? node.data.primary_business_owner
              : node.data.owner?.first_name)
          "
          class="info-icon"
        >
          person
        </mat-icon>

        {{
          node.type === "application"
            ? node.data.primary_business_owner
            : node.type === "infrastructure"
            ? node.data.environment?.display_name
            : node.data.owner?.first_name + " " + node.data.owner?.last_name
        }}
      </span>
    </td>
  </tr>

  <!-- Children -->
  <ng-container *ngIf="treeControl.isExpanded(node)">
    <ng-container
      *ngFor="let child of node.children"
      [ngTemplateOutlet]="recursiveNode"
      [ngTemplateOutletContext]="{ $implicit: child, level: level + 1 }"
    >
    </ng-container>
  </ng-container>
</ng-template>
